module.exports = __webpack_public_path__ + "media/images/1200/sleep_paralysis_night_mare-4851b1f3a22a370865cdd09ba5aec378.jpg";